import React from "react";
import { Link } from "react-router-dom";
import "../css/privacy.scss";

function Privacy() {
  return (
    <main>
      <div className="contained px-16">
        <nav aria-label="Breadcrumb">
          <ol className="text-grey-30 text-14 my-32 list-none font-semibold">
            <li className="inline-flex"><Link className="text-black" to="/">Home</Link></li>
            <li className="inline-flex">Privacy Policy</li>
          </ol>
        </nav>
        <h1 className="text-neutral mb-32 text-center font-light text-30">Privacy Policy</h1>
      </div>

      <div className="tablet:px-0 mb-32 px-16">
        <h2>OVERVIEW</h2>
        <p>
          This policy explains how Jskerandco handles personal information when
          you browse this site, contact us, or place an order. It was last
          updated on September 8, 2026.
        </p>
      </div>
      <div className="tablet:px-0 mb-32 px-16 bg-grey-4 py-32">
        <h2>INFORMATION WE HANDLE</h2>
        <p>
          Depending on how you use the site, we may receive contact details,
          delivery and billing details, order information, product selections,
          and messages you send us. The shopping cart is also saved in your
          browser so it remains available between visits. Payment details may
          be handled by a payment provider and should not be retained by us
          unless clearly stated during checkout.
        </p>
      </div>
      <div className="tablet:px-0 mb-32 px-16">
        <h2>WHY WE USE INFORMATION</h2>
        <p>
          We use information to provide the site, respond to questions, process
          and support orders, prevent misuse, meet legal obligations, and
          improve our services. Where required, we rely on your consent; you may
          withdraw it for future use at any time.
        </p>
      </div>
      <div className="tablet:px-0 mb-32 px-16 bg-grey-4 py-32">
        <h2>SHARING AND RETENTION</h2>
        <p>
          We may share only the information needed with providers that support
          hosting, payment, delivery, security, or customer service, and with
          authorities when the law requires it. We do not sell personal
          information. We keep information only as long as reasonably needed
          for these purposes, including recordkeeping and dispute resolution.
        </p>
      </div>
      <div className="tablet:px-0 mb-32 px-16">
        <h2>YOUR CHOICES</h2>
        <p>
          Your browser lets you clear locally stored cart data and manage
          cookies. See our <Link to="/cookies">Cookie &amp; Local Storage Policy</Link>
          {" "}for the technologies currently used. Depending on your location,
          you may also ask to access,
          correct, delete, restrict, or receive a copy of your personal
          information. Some requests may be limited by applicable law.
        </p>
      </div>
      <div className="tablet:px-0 mb-32 px-16 bg-grey-4 py-32">
        <h2>CONTACT</h2>
        <p>
          Send privacy questions or requests to{" "}
          <a href="mailto:boxes@jskerandco.club">boxes@jskerandco.club</a>.
          We may update this policy when our practices change and will post the
          revised date on this page.
        </p>
      </div>
    </main>
  );
}

export default Privacy;
